import { render } from "./voiceprintSlider.vue?vue&type=template&id=170633cc"
import script from "./voiceprintSlider.vue?vue&type=script&lang=js"
export * from "./voiceprintSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__